import { TGiftCard } from 'types/gift-card';

export const getGiftCard = (state: any): TGiftCard => state?.giftCard;
